/**
 * Customer column: external link to customer profile with click tracking separate from row navigation.
 */
import type { MouseEvent } from "react";
import { observer } from "mobx-react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import ExternalLink from "../../../components/external-link/external-link";
import RmaListItemStore from "../../../rma-list-page/stores/rma-item-store";
import "./table-column-customer.scss";

export interface ITableColumnCustomerProps {
    rma: RmaListItemStore;
}

const TableColumnCustomer: React.FC<ITableColumnCustomerProps> = observer(({ rma }) => {
    const onCustomerClick = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        rmsMixpanelStore.trackEvent("d&_customer");
    };
    return (
        <div className="table-column-customer" onClick={(e) => onCustomerClick(e)}>
            <ExternalLink label={rma.customerName} url={rma.customerUrl} Font={FontBody2} />
        </div>
    );
});

export default TableColumnCustomer;
